const redirectTo = (uri: string) => {
    window.location.href = uri;
};
export default redirectTo;